<div
  class="search-bar"
  [class.search-bar--invalid]="!isValid()"
  [class.search-bar--disabled]="disabled()"
>
  <div class="search-bar__highlight" [innerHTML]="highlightedHtml()" aria-hidden="true"></div>
  <textarea
    class="search-bar__field"
    rows="1"
    [value]="value()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [attr.aria-invalid]="!isValid() ? true : null"
    (input)="onInput($event)"
    (blur)="onBlur()"
  ></textarea>
</div>
@if (!isValid()) {
  <p class="search-bar__hint">{{ validityMessage() }}</p>
}
